<template>
  <div :class="[$style.base, { [$style.isNotLarge]: $screen !== 'l' }]">
    <BaseText v-show="!tableIsLoading || !!totalCount">
      {{ $t('customers.results_found') }}:
      <BaseText
        bold
        inline
        v-test="'customers-total-count'"
      >
        {{ totalCount }}
      </BaseText>
    </BaseText>
    <FilterLabels
      :filters="modelValue"
      @removeFilter="onRemoveFilter"
    />
    <BaseText
      v-show="modelValue && modelValue.length"
      @click="clearFilters"
      v-test="'customersClearFilters'"
    >
      {{ $t('customers.clear_all_filters') }}
    </BaseText>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import FilterLabels from '@/components/customer-filters/FilterLabels.vue';
import { useUserStore } from '@/stores/user';

export default defineComponent({
  components: {
    FilterLabels,
  },
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    tableIsLoading: {
      type: Boolean,
      default: false,
    },
    totalCount: {
      type: Number,
    },
  },
  emits: ['update:modelValue'],
  setup() {
    const selectedCustomers = inject<number[]>('selectedCustomers');
    return {
      selectedCustomers,
    };
  },
  computed: {
    ...mapState(useUserStore, ['user']),
  },
  methods: {
    onRemoveFilter(filter) {
      this.updateModelValue(
        this.modelValue.filter((f) => f.labelIndex !== filter.labelIndex),
      );
    },
    clearFilters() {
      this.updateModelValue([]);
    },
    updateModelValue(filters) {
      this.$emit('update:modelValue', filters);
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: $spacing;
}

.clear {
  cursor: pointer;
}

.alertIcon {
  transform: translateY(3px);
  margin-right: $spacing * 0.25;
}
</style>
